import React from 'react';
import { trackAffiliateClick } from '../../utils/analytics';

export const SURFSHARK_AFFILIATE_URL = 'https://get.surfshark.net/aff_c?offer_id=2065&aff_id=50526';

function AffiliateLink({ placement }) {
  return (
    <a
      className="sv-affiliate-cta"
      href={SURFSHARK_AFFILIATE_URL}
      target="_blank"
      rel="sponsored noopener noreferrer"
      aria-label="Check Surfshark plans (opens in a new tab)"
      onClick={() => trackAffiliateClick(placement)}
    >
      Check Surfshark plans <span aria-hidden="true">↗</span>
    </a>
  );
}

function AffiliateArtwork() {
  return (
    <span className="sv-affiliate-artwork">
      <img
        src="/images/affiliate/surfshark-connection.webp"
        width="960"
        height="640"
        loading="lazy"
        decoding="async"
        alt="Surfshark VPN connection illustration with a phone, laptop and padlock over a football pitch"
      />
    </span>
  );
}

function Disclosure() {
  return (
    <div className="sv-affiliate-disclosure">
      <span className="sv-affiliate-label">Ad</span>
      <span>We earn commission on qualifying purchases.</span>
    </div>
  );
}

export default function SurfsharkAffiliate({ variant = 'full', placement = 'homepage' }) {
  if (variant === 'footer') {
    return (
      <aside className="sv-affiliate sv-affiliate--footer" aria-label="Advertisement">
        <Disclosure />
        <div className="sv-affiliate-card">
          <AffiliateArtwork />
          <div className="sv-affiliate-copy">
            <span className="sv-affiliate-eyebrow">Surfshark for Squadverse</span>
            <strong>Support Squadverse with Surfshark.</strong>
          </div>
          <AffiliateLink placement={placement} />
        </div>
      </aside>
    );
  }

  if (variant === 'setup') {
    return (
      <aside className="sv-affiliate sv-affiliate--setup" aria-labelledby="sv-affiliate-title-setup">
        <Disclosure />
        <div className="sv-affiliate-card">
          <AffiliateArtwork />
          <div className="sv-affiliate-copy">
            <h2 id="sv-affiliate-title-setup">Thinking about a VPN?</h2>
            <p>Explore Surfshark VPN. Qualifying purchases support Squadverse.</p>
          </div>
          <AffiliateLink placement={placement} />
          <p className="sv-affiliate-caveat">A VPN does not make you anonymous.</p>
        </div>
      </aside>
    );
  }

  return (
    <aside className="sv-affiliate sv-affiliate--full" aria-labelledby="sv-affiliate-title-full">
      <Disclosure />
      <div className="sv-affiliate-card">
        <div className="sv-affiliate-copy">
          <span className="sv-affiliate-eyebrow">Support Squadverse</span>
          <h2 id="sv-affiliate-title-full">A more private connection for everyday browsing</h2>
          <ul className="sv-affiliate-benefits">
            <li>Surfshark encrypts the connection between your device and its VPN servers.</li>
            <li>Qualifying purchases through our link support Squadverse.</li>
          </ul>
          <AffiliateLink placement={placement} />
          <p className="sv-affiliate-caveat">
            A VPN does not make you anonymous or replace safe browsing and device security.
          </p>
        </div>
        <AffiliateArtwork />
      </div>
    </aside>
  );
}
